module.exports = __webpack_public_path__ + "static/media/PassingTheFaithOntoLovedOnes.9da78fc7.jpg";